import { createFileRoute, redirect } from '@tanstack/react-router';

// The bare tab URL lands on Project, keeping whatever scope the link carried.
export const Route = createFileRoute('/operating-costs/cost-to-produce/')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/operating-costs/cost-to-produce/project', search });
  },
});
